
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("d7yuH", function(module, exports) {

$parcel$export(module.exports, "DIALOG_SUBMIT_BTN", () => $19577fee6cef2cdd$export$7a6a15706decd0f9);
$parcel$export(module.exports, "safeUnbindDomEvent", () => $19577fee6cef2cdd$export$582c70653d60fda9);
$parcel$export(module.exports, "safeBindDomEvent", () => $19577fee6cef2cdd$export$8e05e1932c4b20b0);
$parcel$export(module.exports, "default", () => $19577fee6cef2cdd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $eusud = parcelRequire("eusud");

var $ctrpc = parcelRequire("ctrpc");

var $d6AeP = parcelRequire("d6AeP");

var $gXz4p = parcelRequire("gXz4p");

var $k0ahW = parcelRequire("k0ahW");

var $dXq4S = parcelRequire("dXq4S");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");

var $6r7fT = parcelRequire("6r7fT");



var $270P6 = parcelRequire("270P6");

var $d7lJH = parcelRequire("d7lJH");

var $55hg5 = parcelRequire("55hg5");
const $19577fee6cef2cdd$export$7a6a15706decd0f9 = '#issue-workflow-transition-submit';
const $19577fee6cef2cdd$export$582c70653d60fda9 = (selector, event, handler)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector(selector);
    if (el) el.removeEventListener(event, handler);
};
const $19577fee6cef2cdd$export$8e05e1932c4b20b0 = (selector, event, handler)=>{
    $19577fee6cef2cdd$export$582c70653d60fda9(selector, event, handler);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector(selector);
    if (el) el.addEventListener(event, handler);
};
// eslint-disable-next-line jira/react/no-class-components
class $19577fee6cef2cdd$var$StatusServiceOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onFailure: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onEditCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    /**
	 * Lets the consumer control the value of this component. If the consumer passes a `value` prop
	 * it will override the value in state, as long as the component is not in loading state. That's because the component
	 * will only let the consumer know about the new status value once the transition is complete (i.e. loading=false).
	 *
	 * This lifecycle method gets called before every invocation of render().
	 */ static getDerivedStateFromProps(props, state) {
        if (state.loading || !props.value) return null;
        return {
            value: props.value
        };
    }
    constructor(props){
        super(props), this.componentDidUpdate = (prevProps)=>{
            if ((0, $4R6GH.fg)('jira-edit-status-field-refresh-state')) {
                const isNewStatus = this.props.initialValue && prevProps.initialValue && prevProps.initialValue.id !== this.props.initialValue.id && this.props.initialValue.id !== this.state.value.id;
                const hasNameChanged = this.props.initialValue && prevProps.initialValue && prevProps.initialValue.name !== this.props.initialValue.name;
                const hasCategoryChanged = this.props.initialValue && prevProps.initialValue && prevProps.initialValue.statusCategory.id !== this.props.initialValue.statusCategory.id;
                if (isNewStatus || this.props.checkRefreshedData && (hasNameChanged || hasCategoryChanged)) this.setState({
                    loading: false,
                    value: this.props.initialValue
                });
            } else if (// If we receive a new prop that is different to the old one and it is different
            // to our state then trust it and update the state.
            this.props.initialValue && prevProps.initialValue && prevProps.initialValue.id !== this.props.initialValue.id && this.props.initialValue.id !== this.state.value.id) this.setState({
                loading: false,
                value: this.props.initialValue
            });
        }, this.isDialogOpened = false, this.isDialogConfirmPressed = false, this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                this.bindDialogFormHandlers();
                this.isDialogOpened = true;
                this.isDialogConfirmPressed = false;
            });
        }, this.bindDialogFormHandlers = ()=>{
            $19577fee6cef2cdd$export$8e05e1932c4b20b0($19577fee6cef2cdd$export$7a6a15706decd0f9, 'click', this.onClickDialogConfirm);
        }, this.unbindDialogFormHandlers = ()=>{
            $19577fee6cef2cdd$export$582c70653d60fda9($19577fee6cef2cdd$export$7a6a15706decd0f9, 'click', this.onClickDialogConfirm);
        }, this.handleBeforeDialogHide = ()=>{
            this.unbindDialogFormHandlers();
            this.isDialogOpened = false;
            this.isDialogConfirmPressed = false;
        }, this.onClickDialogConfirm = ()=>{
            // Dialog confirm button press will result in either successfully closing of dialog, or error and dialog re-rendering,
            // so we are starting both interactions
            this.isDialogConfirmPressed = true;
        }, this.resetError = ()=>this.setState({
                error: null
            }), this.submit = (transition, event)=>{
            const oldValue = this.state.value;
            const newValue = transition.to;
            const isEditFromIssueView = (0, $d6AeP.getIsEditFromIssueView)(event);
            const issueAri = this.props.issueId;
            const issueId = issueAri && (0, $dXq4S.isAri)(issueAri) && (0, $4R6GH.fg)('one_event_iteration_3') ? (0, $dXq4S.getAriConfig)(issueAri).resourceId : issueAri;
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $5fc53.STATUS_TYPE), {
                analytics: event,
                attributes: {
                    fieldType: (0, $5fc53.STATUS_TYPE),
                    oldValId: oldValue.statusId ?? oldValue.id,
                    newValId: newValue.id,
                    oldStatusCategoryId: oldValue.statusCategory.id,
                    newStatusCategoryId: newValue.statusCategory.id,
                    isInlineEditing: !isEditFromIssueView,
                    ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                        issueId: issueId
                    }
                }
            });
            this.setState({
                loading: true,
                value: newValue
            });
            this.props.onSubmit(oldValue, newValue, {
                transition: transition
            }, event);
        }, this.success = ({ status: status, event: event, viaDialog: viaDialog = false })=>{
            this.setState({
                loading: false,
                lastSavedValue: status
            });
            this.props.fieldValueActions.setFieldValue(this.props.issueKey, (0, $5fc53.STATUS_TYPE), status);
            this.props.onSuccess(status, viaDialog, event);
            (0, $8zOmE.fireTrackAnalytics)(event, 'statusField transitioned', 'statusField');
            (0, $gXz4p.sendExperienceAnalytics)((0, $270P6.transitionIssueExperienceDescription)(true, 'POST', (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? this.props.source ?? '' : 'Issue View Status Service', this.props.projectType));
        }, this.failure = (error, event)=>{
            this.setState({
                error: error,
                loading: false,
                value: this.state.lastSavedValue || this.props.value || this.props.initialValue
            });
            this.props.onFailure(error);
            const isValidationError = error instanceof (0, $jJZqs.ValidationError);
            if (isValidationError) this.props.flagService.showFlag((0, $55hg5.default)(error.message));
            else this.props.flagService.showFlag((0, $d7lJH.default)({
                error: error,
                traceId: error.traceId
            }));
            (0, $8zOmE.fireOperationalAnalytics)(event, 'statusField postTransitionFailed', {
                validationError: isValidationError,
                isClientFetchError: (0, $fZneA.isClientFetchError)(error)
            });
            if ((0, $k0ahW.default)(error) || (0, $4R6GH.fg)('thor_resolve_transition_event_gate')) (0, $gXz4p.sendExperienceAnalytics)((0, $270P6.transitionIssueExperienceDescription)(false, 'POST', (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? this.props.source ?? '' : 'Issue View Status Service', this.props.projectType, error.message, error.traceId, error.statusCode, (0, $6r7fT.isAbortableError)(error) && (0, $4R6GH.fg)('thor_add_taskabort_events_for_core_experiences') ? 'taskAbort' : 'taskFail'));
            else (0, $gXz4p.sendExperienceAnalytics)((0, $270P6.transitionIssueExperienceDescription)(true, 'POST', (0, $4R6GH.fg)('thor_resolve_transition_event_gate') ? this.props.source ?? '' : 'Issue View Status Service', this.props.projectType));
        }, this.cancel = ()=>{
            // @ts-expect-error - TS2322 - Type 'Status | undefined' is not assignable to type 'Status'.
            this.setState({
                loading: false,
                value: this.props.value || this.props.initialValue
            });
            this.props.onEditCancel();
            this.props.workflowTransitionsActions.setTransitionInProgress(false);
        }, this.transitionStatus = async (transition, event)=>{
            const { appearance: appearance, issueKey: issueKey, renderIssueTransitionModal: renderIssueTransitionModal, renderIssueTransitionSuccessFlag: renderIssueTransitionSuccessFlag } = this.props;
            const newStatus = transition.to;
            this.submit(transition, event);
            try {
                if (transition.hasScreen) {
                    const handleDialogSuccess = ()=>{
                        (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition success', {
                            triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                            isModalOpen: true
                        });
                        (0, $4R6GH.fg)('show-modernised-issue-transition-success-flag') && renderIssueTransitionSuccessFlag?.(issueKey, newStatus.name);
                        return this.success({
                            status: newStatus,
                            event: event,
                            viaDialog: true
                        });
                    };
                    const handleDialogCancel = ()=>{
                        (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition cancel', {
                            triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                            isModalOpen: true
                        });
                        return this.cancel();
                    };
                    const handleDialogError = ()=>{
                        (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition failed', {
                            triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                            isModalOpen: true
                        });
                    };
                    if (renderIssueTransitionModal) {
                        const { issueId: issueId } = this.props;
                        renderIssueTransitionModal({
                            payload: {
                                issueId: issueId,
                                issueKey: issueKey,
                                transitionId: transition.id
                            },
                            triggerPointKey: appearance === 'lozenge' ? 'issue-transition-status-field-trigger' : 'issue-transition-issue-view',
                            onDialogSuccess: handleDialogSuccess,
                            onDialogCancel: handleDialogCancel,
                            onDialogError: handleDialogError,
                            analyticsEvent: event
                        });
                    }
                } else {
                    if (this.props.onUpdateStatusMutation && (0, $4R6GH.fg)('relay-migration-issue-fields-status')) await this.props.onUpdateStatusMutation?.({
                        transitionId: transition.id,
                        newStatus: newStatus
                    });
                    else await (0, $eusud.performPostRequest)(`/rest/api/2/issue/${issueKey}/transitions`, {
                        body: JSON.stringify({
                            transition: transition
                        })
                    });
                    (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition success', {
                        triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                        isModalOpen: false
                    });
                    (0, $4R6GH.fg)('show-modernised-issue-transition-success-flag') && renderIssueTransitionSuccessFlag?.(issueKey, newStatus.name);
                    this.success({
                        status: newStatus,
                        event: event
                    });
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $878fbedb9c4ca329$export$25529a3376b831fd), error);
                (0, $8zOmE.fireTrackAnalytics)(event, 'issueTransition failed', {
                    triggerPointKey: (0, $5101b286174175c1$export$a6eb4c39beb71474),
                    isModalOpen: false
                });
                this.failure(error, event);
            }
        }, this.api = {
            transitionStatus: this.transitionStatus,
            resetError: this.resetError
        };
        const value = props.value || props.initialValue;
        if (value == null) throw new Error('Either value or initialValue prop is required.');
        this.state = {
            value: value,
            lastSavedValue: value,
            loading: false,
            error: null
        };
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogContentReady', this.onDialogContentReady);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogBeforeHide', this.handleBeforeDialogHide);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('legacyJiraDialogContentReady', this.onDialogContentReady);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('legacyJiraDialogBeforeHide', this.handleBeforeDialogHide);
        this.unbindDialogFormHandlers();
        this.isDialogOpened = false;
    }
    render() {
        return this.props.children({
            ...this.state,
            ...this.api
        });
    }
}
var $19577fee6cef2cdd$export$2e2bcd8739ae039 = $19577fee6cef2cdd$var$StatusServiceOld;

});
const $878fbedb9c4ca329$export$71a8e2ae8cfade56 = 'issue-field.status.fetch-transitions';
const $878fbedb9c4ca329$export$25529a3376b831fd = 'issue-field.status.post-transition';
const $878fbedb9c4ca329$export$4bf6353caa97e8e7 = 'issue-field.status.fetch-view-workflow';
const $878fbedb9c4ca329$export$136fc24ec1bfcefd = 'VIEW_READONLY_WORKFLOW';
const $878fbedb9c4ca329$export$624e7abc8d9cada5 = 'ADMINISTER';

const $5101b286174175c1$export$a6eb4c39beb71474 = 'issue-transition-status-field';

parcelRegister("d7lJH", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf133abbd76f3557$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $bf133abbd76f3557$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-field-status.services.flags.transition-failed-error.main.title",
        "defaultMessage": "We couldn't update the status"
    },
    description: {
        "id": "issue-field-status.services.flags.transition-failed-error.main.description",
        "defaultMessage": "Check your network connection, then try reloading the issue."
    }
});
const $bf133abbd76f3557$var$statusTransitionErrorFlag = (flagConfig)=>({
        messageId: `issue.fields.status.services.flags.transition-failed-error.flag.error.${flagConfig?.error?.name}`,
        messageType: 'transactional',
        type: 'error',
        title: $bf133abbd76f3557$var$messages.title,
        description: $bf133abbd76f3557$var$messages.description,
        isAutoDismiss: true,
        ...flagConfig || {}
    });
var $bf133abbd76f3557$export$2e2bcd8739ae039 = $bf133abbd76f3557$var$statusTransitionErrorFlag;

});

parcelRegister("55hg5", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d918a4398288451$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $7d918a4398288451$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-field-status.services.flags.validation-error.main.title",
        "defaultMessage": "Transition failed"
    }
});
const $7d918a4398288451$var$statusTransitionValidationErrorFlag = (description)=>({
        messageId: 'issue-field-status.services.flags.validation-error.flag.warning.error',
        messageType: 'transactional',
        type: 'warning',
        title: $7d918a4398288451$var$messages.title,
        description: {
            id: 'issue-field.status.services.flags.validation-error.main.description',
            defaultMessage: description
        },
        isAutoDismiss: true
    });
var $7d918a4398288451$export$2e2bcd8739ae039 = $7d918a4398288451$var$statusTransitionValidationErrorFlag;

});



$parcel$global.rlb("7B2gt")
//# sourceMappingURL=status-service-old.889ab7c0.js.map
